module.exports = __webpack_public_path__ + "media/images/regional-image21-0b637ef6aba1096e784ce6fdbcc566cf.jpg";